<div class="newAssetSitePickerWorkspace">
  <div class="newAssetSitePickerSite">
    <div class="collapseChevronContainer">
      @if (customFields.length > 0) {
        <pp-icon
        [ppSrc]="
          expanded ? EIconPath.ICON_MISC_DOWN_CHEVRON_24 : EIconPath.ICON_MISC_RIGHT_CHEVRON_24
        "
          ppClass="setSize24"
          ppColor="inherit"
          (click)="updateExpanded()"
        ></pp-icon>
      }
    </div>

    <pp-checkbox
      ppSize="medium"
      ppType="solid"
      [ppChecked]="checked"
      (click)="updateChecked()"
    ></pp-checkbox>

    <span>
      <span class="newAssetSitePickerName">
        {{ workspace.siteName }}
      </span>

      <span class="newAssetSitePickerRole">({{ role }})</span>
    </span>
  </div>

  @if (expanded) {
    @for (customField of customFields; track customField) {
      <div class="newAssetSitePickerFields">
        <pp-radio
          ppSize="small"
          [ppChecked]="checkedCustomFieldId === customField.value"
          (ppOnValueChange)="updateCustomFieldChecked(customField)"
          ppStyle="blue"
        ></pp-radio>
        <span>{{ customField.label }}</span>
      </div>
    }
  }
</div>
